import { Box, Typography } from '@mui/material';
import { SxProps } from '@mui/system';
import React, { Fragment, useRef, useState } from 'react';
import Slider from 'react-slick';
import { useStyling } from '../Theme';
import { Icons } from '../icons/Icons';
import Loading from './Loading';

const useCarouselStyling = () => {
    const { theme, isMobile } = useStyling();

    const chevronSize = 24;
    const chevronContainerSx: SxProps = {
        display: 'flex',
        width: chevronSize,
        textAlign: 'center',
        position: 'absolute',
        top: 0,
        bottom: 0
    };
    const bgColor = 'rgba(255, 255, 255, 1)';
    const bgColorHover = theme.palette.primary.main;
    // theme.palette.augmentColor({})
    const fgColor = theme.palette.text.disabled; //getContrastText(bgColor);
    const fgColorHover = theme.palette.getContrastText(bgColorHover);
    const chevronSx: SxProps = {
        height: chevronSize,
        width: chevronSize,
        borderRadius: chevronSize / 2,
        color: fgColor,
        backgroundColor: bgColor,
        border: `1px solid ${fgColor}`,
        alignSelf: 'center',
        '&:hover': {
            cursor: 'pointer',
            color: fgColorHover,
            backgroundColor: bgColorHover,
            border: `1px solid ${fgColorHover}`
        }
        // filter: `drop-shadow(5px 5px 5px ${theme.palette.text.disabled})`
    };
    const countContainerSx = {
        display: 'flex',
        p: 1,
        pt: 0.5,
        pb: 0.5,
        backgroundColor: bgColor,
        color: fgColor,
        textAlign: 'center',
        position: 'absolute',
        top: 0,
        right: chevronSize / 2,
        borderBottomLeftRadius: '4px' // .5
    };
    return { chevronSize, chevronContainerSx, chevronSx, countContainerSx };
};

type CarouselProps = {
    single?: boolean;
    loading?: boolean;
    slidesToScroll?: number;
    containerSx?: SxProps;
    children: any;
};

export default (props: CarouselProps) => {
    const { single, loading, containerSx, children, slidesToScroll } = props;
    const [current, setCurrent] = useState(0);
    const { theme, isMobile } = useStyling();
    const ref = useRef<Slider>(undefined);
    const realSlidesToScroll = slidesToScroll ? slidesToScroll : single || isMobile ? 1 : 3;
    const config = {
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: realSlidesToScroll,
        dots: false, //single,
        focusOnSelect: false,
        swipeToSlide: true,
        touchThreshold: 1000,
        infinite: false,
        centerMode: false,
        variableWidth: !single,
        speed: 300
    };

    const { chevronSize, chevronContainerSx, chevronSx, countContainerSx } = useCarouselStyling();
    return (
        <Box
            className="_carouselContainer"
            sx={{
                ...containerSx,
                width: '100%',
                position: 'relative',
                px: 2,
                '&:hover': {
                    cursor: 'grab'
                }
            }}
        >
            <Slider ref={(c) => (ref.current = c)} {...config} afterChange={(curr) => setCurrent(curr)}>
                {children}
            </Slider>
            {single ? (
                <Box sx={countContainerSx}>
                    <Typography fontSize={'small'}>
                        {current + 1} / {children.length}
                    </Typography>
                </Box>
            ) : (
                <></>
            )}
            <Box className={'carousel-nav'} sx={{ left: `${(32 - chevronSize) / 2}px`, ...chevronContainerSx }}>
                <Icons.ChevronLeft
                    sx={chevronSx}
                    onClick={() => {
                        ref?.current?.slickPrev();
                    }}
                />
            </Box>
            <Box className={'carousel-nav'} sx={{ right: `${(32 - chevronSize) / 2}px`, ...chevronContainerSx }}>
                <Icons.ChevronRight
                    sx={chevronSx}
                    onClick={() => {
                        ref?.current?.slickNext();
                    }}
                />
            </Box>
            {loading ? (
                <Loading
                    sx={{
                        position: 'absolute',
                        top: 0,
                        backgroundColor: 'rgba(0,0,0,.5)'
                    }}
                />
            ) : (
                <Fragment />
            )}
        </Box>
    );
};
